module.exports = __webpack_public_path__ + "d3bfb7618507726815aa240adcebe75c.svg";